export enum MOUNTAINS {
  HELLO_WORLD_MOUNTAIN = "HELLO_WORLD_MOUNTAIN",
  TRAVEL_MOUNTAIN = "TRAVEL_MOUNTAIN",
  AUTH_MOUNTAIN = "AUTH_MOUNTAIN",
  CLIENT_MOUNTAIN = "CLIENT_MOUNTAIN",
}
